import React from 'react';
import PropTypes from 'prop-types';

import { ButtonFilled, SvgIcon, Text, Flex } from 'Components/Base';

const NextSubsectionButton = ({
  countdown,
  enabledCountdown,
  onAutoPlay,
  isLastSubsectionInCourse,
}) => {
  return (
    <ButtonFilled
      width={'100%'}
      height={'130px'}
      onClick={onAutoPlay}
      borderRadius={2}
      color={'primary'}
    >
      <Flex justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
        <SvgIcon
          icon={SvgIcon.ICON_LIST.SKIP_NEXT}
          size={36}
          color={'videoOverlayDescription'}
          mb={1}
        />
        <Flex justifyContent={'center'} alignItems={'flex-end'}>
          <Text textStyle={'heading5'} color={'videoOverlayDescription'} mr={1}>
            {isLastSubsectionInCourse ? 'กลับหน้าแรก' : 'เรียนต่อ'}
          </Text>
          {enabledCountdown && (
            <Text textStyle={'body1Medium'} color={'whites.8'}>
              ({countdown}s)
            </Text>
          )}
        </Flex>
      </Flex>
    </ButtonFilled>
  );
};

NextSubsectionButton.propTypes = {
  countdown: PropTypes.number,
  enabledCountdown: PropTypes.bool,
  onAutoPlay: PropTypes.func,
  isLastSubsectionInCourse: PropTypes.bool,
  isClickedContent: PropTypes.bool,
};

export default NextSubsectionButton;
